import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Icon, Link, Show, useBoolean, Text, HStack } from "@chakra-ui/react"
import { TbLayoutSidebarRightCollapse, TbLayoutSidebarRightExpand } from "react-icons/tb";
import InvoiceDetail from "../pages/Invoices/InvoiceDetail";
import { InvoiceSummaryType } from "../types";

type InvoiceDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  invoice: InvoiceSummaryType;
}

function InvoiceDrawer({isOpen, onClose, invoice}: InvoiceDrawerProps) {
    const [drawerExpand, setDrawerExpand] = useBoolean(false);
    const drawerExpandIcon = (drawerExpand) ? TbLayoutSidebarRightCollapse : TbLayoutSidebarRightExpand;
    const drawerSize = (drawerExpand) ? "95%" : "50%";

    return (
        <Drawer onClose={onClose} isOpen={isOpen} size={'xl'} returnFocusOnClose={false}>
            <DrawerOverlay />
            <DrawerContent maxW={{ base: "90%", lg: drawerSize }}>
                <DrawerCloseButton />
                <DrawerHeader backgroundColor={"purple.100"} color={"white"} >
                    <HStack>
                        <Link onClick={setDrawerExpand.toggle}><Show above='lg'><Icon as={drawerExpandIcon}/></Show></Link>
                        <Text>Invoice Details</Text>
                    </HStack>
                </DrawerHeader>
                <DrawerBody backgroundColor={"purple.10"}>
                    <InvoiceDetail invoice={invoice} supply_number={invoice.supply_number} />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )

}

export default InvoiceDrawer